export { default } from './SWFlippingCard';
